import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white border border-primary rounded-3 p-3 mt-3" }
const _hoisted_2 = { class: "table table-borderless" }
const _hoisted_3 = { class: "small" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-end" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import UserGoal, { MilestoneExam } from '../../../api/v2/models/user_goal'
import UserGoalUserExam from '../atoms_molecules/UserGoalUserExam.vue'
import { ROUTER_NAME } from '../../router'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGoalSuggestion',
  props: {
    userGoal: {}
  },
  setup(__props: any) {

const router = useRouter()

// Props
const props = __props

// Computed
const latestJoinedExam = computed(() => props.userGoal.latestJoinedExams[0])

// Functions
function gotoExamResult(exam: MilestoneExam) {
  if (!exam || !exam.userExam) {
    return
  }
  router.push({
    name: ROUTER_NAME.EXAM_RESULT,
    params: {
      examId: `${exam.id}`
    },
    query: {
      user_exam_id: `${exam.userExam.id}`
    }
  })
}

function gotoExams() {
  router.push({
    name: ROUTER_NAME.MY_EXAM_LIST
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (latestJoinedExam.value && latestJoinedExam.value.userExam)
      ? (_openBlock(), _createBlock(UserGoalUserExam, {
          key: 0,
          userGoal: __props.userGoal,
          userExamId: latestJoinedExam.value.userExam.id
        }, null, 8 /* PROPS */, ["userGoal", "userExamId"]))
      : _createCommentVNode("v-if", true),
    _cache[1] || (_cache[1] = _createElementVNode("hr", {
      role: "separator",
      "aria-orientation": "horizontal",
      class: "mx-0 v-divider theme--light"
    }, null, -1 /* CACHED */)),
    _createElementVNode("table", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "small text-gray" }, [
          _createElementVNode("th", { class: "" }),
          _createElementVNode("th", { class: "text-end" }, "スコア")
        ])
      ], -1 /* CACHED */)),
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userGoal.latestJoinedExams.slice(1), (exam, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: ""
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("a", {
                class: "text-decoration-none",
                onClick: ($event: any) => (gotoExamResult(exam))
              }, _toDisplayString(exam.name), 9 /* TEXT, PROPS */, _hoisted_5)
            ]),
            _createElementVNode("td", _hoisted_6, [
              (exam.userExamScore !== null && !exam.hideResult)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(exam.userExamScore) + "% ", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (exam.userExamScore !== null && exam.hideResult)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" 結果公開待ち ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", { class: "text-end" }, [
      _createElementVNode("a", {
        class: "small text-decoration-none",
        onClick: gotoExams
      }, "一覧")
    ])
  ]))
}
}

})